export enum Tab {
  COURSES = 'courses',
  COMMUNITIES = 'communities'
}

export type HandleChangeTabParams = {
  event: React.MouseEvent | React.KeyboardEvent
  name: Tab
  disabled: boolean
}
